import { gql } from '@apollo/client'

export const DXO_EXECUTION = gql`
  fragment DXOExecution on DXOExecution {
    id
    name
    address
    numDistinctPriorities
    compliancePercentage
    previousCompliancePercentage
    compliancePercentChange
    numDistinctPriorities
    numStores
    numAuditedStores
    deployedExecuteNumerator
    deployedExecuteDenominator
    deployedSellNumerator
    deployedSellDenominator
    correctPricingPercentage
    rank
  }
`
